import { ref, type VNode } from "vue"
import { unwrapElementRef } from "./unwrap";

export const useElement = () => {
  const elref = ref();
  const element = ref<Element | HTMLElement>(document.createElement('div'));

  const takeElement = (node: VNode) => {
    const el = unwrapElementRef(node);
    if (!el) return;
    element.value = el;
  }
  
  const onBeforeMount = (node: VNode) => {
    elref.value = node;
    takeElement(node);
  }

  const onNodeMounted = (node: VNode) => {
    elref.value = node;
    takeElement(node);
  }

  const onNodeBeforeUnmount = () => {
    elref.value = null;
  }

  const onNodeUpdated = (node: VNode) => {
    takeElement(node);
    if (!elref.value) {
      elref.value = node;
    }
  }

  return {
    props: {
      onVnodeBeforeMount: onBeforeMount,
      onVnodeMounted: onNodeMounted,
      onVnodeUpdated: onNodeUpdated,
      onVnodeBeforeUnmount: onNodeBeforeUnmount 
    },
    node: elref,
    element: element
  }
}
